import { render } from "./RankLastweekComponent.vue?vue&type=template&id=1baba15e"
import script from "./RankLastweekComponent.vue?vue&type=script&lang=js"
export * from "./RankLastweekComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__